module.exports = __webpack_public_path__ + "static/media/black-tshirt-woman-back-min.df59deaa.png";